import { SonarText } from '@ui/text';
import { useFeatureFlag } from '@hooks';
import { Else, If, Then } from 'react-if';
import React from 'react';
export const TimelineFilterSection = ({ children, featureFlag, hidden, title }) => {
    const isEnabled = useFeatureFlag(featureFlag, true);
    if (!children) {
        return null;
    }
    if (!isEnabled || hidden) {
        return null;
    }
    return (React.createElement("div", { className: 'timeline-filter-section' },
        React.createElement(If, { condition: typeof title === 'string' },
            React.createElement(Then, null,
                React.createElement(SonarText, { className: 'h3' }, title)),
            React.createElement(Else, null, title)),
        children));
};
